import Utils from './utils.js';
import GeoTrace from '../geo-script.js';

/**
 * Class Geo Visibility
 */
export default class elementorGeoVisibility {
	constructor() {
		this.setSettings();
	}

	/**
	 * Set this instance settings.
	 */
	setSettings() {
		// The loader class
		this.loadingSelector = '.geo-visibility-loader';
	}

	/**
	 * Remove geo loader elements from DOM
	 */
	hideLoading() {
		const element = document.querySelector( this.loadingSelector );
		if ( element ) {
			element.remove();
		}
	}

	/**
	 * Run the default behavior on each element
	 *
	 * @param $item
	 * @param defaultBehavior
	 */
	initDefaultBehavior( element, defaultBehavior ) {
		if ( defaultBehavior ) {
			element.classList.remove( Utils.hideClass );
		}
	}

	/**
	 * Handle geo visibility conditions.
	 * Remove "hideClass" from element if pass the geo validation.
	 *
	 * @returns {Promise<void>}
	 */
	async handleGeoConditions( element, elementData, isAllHideElement, showAllHideElement ) {

		const geoTrace = new GeoTrace();
		const locationCode = await geoTrace.getLocationCode();

		const geoSettings = elementData.geo_settings;

		if ( geoTrace.fetchError ) {
			console.error( 'Fetch error' );
			this.initDefaultBehavior( element, elementData.default );
		}
		else if ( this.geoShow( geoSettings, locationCode ) || this.geoNotHide( geoSettings, locationCode ) ) {
			element.classList.remove( Utils.hideClass );
		}
		else if ( this.geoHide( geoSettings, locationCode ) && isAllHideElement ) {
			showAllHideElement.show = false;
		}

		this.hideLoading();

	}

	/**
	 * geo settings SET & showing for current location.
	 *
	 * @param geoSettings
	 * @param locationCode
	 * @returns {boolean}
	 */
	geoShow( geoSettings, locationCode ) {
		return ( geoSettings.show && geoSettings.show.length > 0 && geoSettings.show.indexOf( locationCode ) >= 0 );
	}

	/**
	 * geo settings SET but not hiding for current location.
	 *
	 * @param geoSettings
	 * @param locationCode
	 * @returns {boolean}
	 */
	geoNotHide( geoSettings, locationCode ) {
		return ( geoSettings.hide && geoSettings.hide.length > 0 && geoSettings.hide.indexOf( locationCode ) < 0 );
	}

	/**
	 * geo settings SET & hiding for current location.
	 *
	 * @param geoSettings
	 * @param locationCode
	 * @returns {boolean}
	 */
	geoHide( geoSettings, locationCode ) {
		return ( geoSettings.hide && geoSettings.hide.length > 0 && geoSettings.hide.indexOf( locationCode ) !== (-1) );
	}

}
